import type { ReactNode } from 'react';

import { View } from '../../primitives/View';
import { cn } from '../../utils/cn';

/**
 * Web: the veil fades on a CSS opacity transition — 200ms ease-out, the
 * `CHAT_ATTACHMENT_FADE_MS` the `.native` sibling runs on Reanimated. Reduced
 * motion drops the transition, so the preview turns crisp at once.
 */
export function AttachmentVeilFade({
  visible,
  children,
}: {
  visible: boolean;
  children: ReactNode;
}) {
  return (
    <View
      className={cn(
        'absolute inset-0 transition-opacity duration-200 ease-out motion-reduce:transition-none',
        visible ? 'opacity-100' : 'pointer-events-none opacity-0',
      )}>
      {children}
    </View>
  );
}
